import * as crypto from "crypto";

export const toSHA256Hex = (value: string | number): string => {
  const stringValue = value.toString();
  const hash = crypto.createHash("sha256");
  hash.update(stringValue);
  return hash.digest("hex");
};
